import { createSelector } from 'reselect';

const getActiveProductsSelector = state =>
  state.funnels.products.items.filter(p => p.active);
const getScoresSelector = state => state.funnels.scores.items;
const getExclusionsSelector = state => state.funnels.exclusions.items;

function scoresForProduct(scores, product) {
  return scores
    .filter(s => s.product.toString() === product.id.toString())
    .toArray();
}

function exclusionsForProduct(exclusions, product) {
  return exclusions
    .filter(e => e.product === product.id)
    .sortBy(exclusion => -exclusion.order)
    .toArray();
}

export const getProductsWithDecision = createSelector(
  getActiveProductsSelector,
  getScoresSelector,
  getExclusionsSelector,
  (products, scores, exclusions) => {
    return products
      .map(p => {
        return {
          ...p,
          scores: scoresForProduct(scores, p),
          exclusions: exclusionsForProduct(exclusions, p),
        };
      })
      .sortBy(p => p.name)
      .toArray();
  }
);



// WEBPACK FOOTER //
// ./src/modules/funnel/selectors/product.js